const READ_URL      = process.env.REACT_APP_N8N_QNA_READ_URL;
const UPDATE_URL    = process.env.REACT_APP_N8N_QNA_UPDATE_URL;
const EMAIL_URL     = process.env.REACT_APP_N8N_QNA_EMAIL_URL;
const CATEGORIES_URL = process.env.REACT_APP_N8N_QNA_CATEGORIES_URL;
const SECRET        = process.env.REACT_APP_N8N_SECRET;

const authHeaders = { 'x-api-key': SECRET || '' };

const checkConfig = (url, name) => {
  if (!url) throw new Error(`${name} غير مضبوط في ملف .env`);
};

const parseJSON = async (res) => {
  const text = await res.text();
  if (!text || !text.trim()) throw new Error(`الخادم أعاد استجابة فارغة (${res.status})`);
  try {
    return JSON.parse(text);
  } catch {
    throw new Error(`استجابة غير صالحة من الخادم: ${text.slice(0, 120)}`);
  }
};

const get = async (url) => {
  checkConfig(url, 'REACT_APP_N8N_QNA_READ_URL');
  const res = await fetch(url, { headers: authHeaders });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = await parseJSON(res);
  if (json.error) throw new Error(json.error);
  return json;
};

const post = async (url, params) => {
  checkConfig(url, 'REACT_APP_N8N_QNA_UPDATE_URL');
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...authHeaders,
    },
    body: new URLSearchParams(params).toString(),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = await parseJSON(res);
  if (json.error) throw new Error(json.error);
  return json;
};

const qnaService = {
  getAll:        ()                   => get(READ_URL),
  updateSheikh:  (id, sheikh)         => post(UPDATE_URL, { action: 'updateSheikh', id, value: sheikh }),
  updateStatus:  (id, status)         => post(UPDATE_URL, { action: 'updateStatus', id, value: status }),
  updateAnswer:  (id, answer)         => post(UPDATE_URL, { action: 'updateAnswer', id, value: answer }),
  updateNotes:   (id, notes)          => post(UPDATE_URL, { action: 'updateNotes',    id, value: notes }),
  updateCategory:(id, category)       => post(UPDATE_URL, { action: 'updateCategory', id, value: category }),
  createCategory:     (name)         => post(CATEGORIES_URL, { action: 'create', name }),
  updateCategoryName: (id, name)     => post(CATEGORIES_URL, { action: 'update', id, name }),
  deleteCategory:     (id)           => post(CATEGORIES_URL, { action: 'delete', id }),
  sendEmail: (q) => {
    if (!EMAIL_URL) throw new Error('REACT_APP_N8N_QNA_EMAIL_URL غير مضبوط في ملف .env');
    return post(EMAIL_URL, {
      action:       'sendAnswerEmail',
      id:           q.id,
      email:        q.email,
      name:         q.name,
      ticketNumber: q.ticketNumber || '',
      question:     q.question,
      answer:       q.answer,
    });
  },
};

export default qnaService;
